import api from './api';

export async function getBranchInventory(branchId) {
  const { data } = await api.get(`/inventory/branch/${branchId}`);
  return data;
}

export async function createInventory(payload) {
  const { data } = await api.post('/inventory', payload);
  return data;
}

export async function updateInventory(id, payload) {
  const { data } = await api.put(`/inventory/${id}`, payload);
  return data;
}

export async function getTransfers() {
  const { data } = await api.get('/transfer');
  return data;
}

export async function getRecentTransfers() {
  const { data } = await api.get('/transfer/recent');
  return data;
}

export async function getCriticalStock() {
  const { data } = await api.get('/inventory/critical');
  return data;
}

export async function createTransfer(payload) {
  const { data } = await api.post('/transfer', payload);
  return data;
}
